import React from "react";
import { Table } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import styles from "./styles.module.scss";

export const ComputersDetailTable2 = ({ columns, data }) => {
  return (
    <Table
      columns={columns}
      dataSource={data}
      bordered
      pagination={false}
      className={styles.table}
      rowClassName={(record, index) =>
        index === 0
          ? styles["custom-padding-column0"]
          : styles["custom-padding-column2"]
      }
    />
  );
};
